import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { getSupplierScheduledPayments } from '../../../../redux/services/paymentsService';
import { ScheduledPaymentsSection } from '../../../general/ScheduledPaymentsSection/ScheduledPaymentsSection';
import { ScheduledPaymentWithNames } from '../../../general/ScheduledPaymentsSection/scheduledPaymentDisplay';

/**
 * Read-only view of the future-dated payments customers have queued to this supplier.
 *
 * No reschedule or cancel: the schedule is the buyer's authorisation to move their own money. The
 * copy says "expected" deliberately — a customer can still cancel, and the run date drops any invoice
 * settled in the meantime, so none of this is committed cash.
 */
export const SupplierScheduledPayments = () => {
  const dispatch = useAppDispatch();
  const currentSupplier = useAppSelector((state) => state.auth.currentSupplier);
  const { supplierScheduledPayments, loadingList } = useAppSelector((state) => state.payments);

  useEffect(() => {
    if (currentSupplier?.id) {
      dispatch(getSupplierScheduledPayments({ supplierId: currentSupplier.id }));
    }
  }, [currentSupplier?.id]);

  return (
    <ScheduledPaymentsSection
      title="Expected Scheduled Payments"
      description="Payments customers have scheduled for a future date. These are not guaranteed — a customer can still cancel, and invoices already settled by then are skipped. Expand one to see the invoices it covers."
      scheduledPayments={supplierScheduledPayments}
      isLoading={loadingList.includes('getSupplierScheduledPayments')}
      counterpartyLabel="Customer"
      counterpartyNameFor={(scheduledPayment: ScheduledPaymentWithNames) =>
        scheduledPayment.buyerName || scheduledPayment.buyerId
      }
    />
  );
};
